import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _26ac6424 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _ce244c34 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _80ad77ee = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _598560f5 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _78e29d95 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _53bc8741 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _cea70782 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _61c2615a = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _1d86ab63 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _780df4f8 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5537ff58 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _56005238 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _32ba2815 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1b64a266 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _0e025e78 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _24583142 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _009abbd5 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _e6021434 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _e37b7574 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _5750f17f = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _0716517d = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _570a7f1e = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _8dcd2948 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _1049cd22 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _c31cb97a = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _69ba2c5d = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _443b450a = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _187fb666 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _e64dc9f8 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _5facda89 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _5f2df9a0 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _7d933658 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _1dd909cc = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _1e68ceec = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _3cd9c4b6 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _4abcbc8e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _4190dee5 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _6c84c32a = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _216375eb = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _7501d792 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _2ae67cb0 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _122eae85 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _0cc60f70 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _3bff89d4 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _5c5a057e = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _24e384d0 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _9da812c0 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _70631158 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _706456db = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _928849ba = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _17d08e48 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _2638dece = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _688a6bfe = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _39c24966 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _e131ee06 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _7ae1e942 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _03676563 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _8e911364 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _16749f9c = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _5fb1a205 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _432de408 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _66aa2280 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _bbb37566 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _268e73d6 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _0b9ab4b1 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _e0f6ee1e = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _0235013d = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _147e2a8b = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _ae241080 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _cd83d1a4 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _2a8ae5fc = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _29b35df0 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _e58f3ef0 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _4b6d82a0 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _26ac6424,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _ce244c34,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _80ad77ee,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _598560f5,
    name: "calendar"
  }, {
    path: "/customer",
    component: _78e29d95,
    name: "customer"
  }, {
    path: "/details",
    component: _53bc8741,
    name: "details"
  }, {
    path: "/goals",
    component: _cea70782,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _61c2615a,
    name: "maisoku"
  }, {
    path: "/media",
    component: _1d86ab63,
    name: "media"
  }, {
    path: "/privacy",
    component: _780df4f8,
    name: "privacy"
  }, {
    path: "/project",
    component: _5537ff58,
    name: "project"
  }, {
    path: "/response",
    component: _56005238,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _32ba2815,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1b64a266,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _0e025e78,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _24583142,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _009abbd5,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _e6021434,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _e37b7574,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _5750f17f,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _0716517d,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _570a7f1e,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _8dcd2948,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _1049cd22,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _c31cb97a,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _69ba2c5d,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _443b450a,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _187fb666,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _e64dc9f8,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _5facda89,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _5f2df9a0,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _7d933658,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _1dd909cc,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _1e68ceec,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _3cd9c4b6,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _4abcbc8e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _4190dee5,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _6c84c32a,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _216375eb,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _7501d792,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _2ae67cb0,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _122eae85,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _0cc60f70,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _3bff89d4,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _5c5a057e,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _24e384d0,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _9da812c0,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _70631158,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _706456db,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _928849ba,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _17d08e48,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _2638dece,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _688a6bfe,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _39c24966,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _e131ee06,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _7ae1e942,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _03676563,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _8e911364,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _16749f9c,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _5fb1a205,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _432de408,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _66aa2280,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _bbb37566,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _268e73d6,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _0b9ab4b1,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _e0f6ee1e,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _0235013d,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _147e2a8b,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _ae241080,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _cd83d1a4,
    name: "property-property",
    children: [{
      path: "contact",
      component: _2a8ae5fc,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _29b35df0,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _e58f3ef0,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _4b6d82a0,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
